import store from "../Redux/Store";

export default function checkIfItemGstDetailsExists(itemData) {
  const isGSTEnabled = !!store.getState().gstBillingReducer.gstBilling?.gst_enabled;
  const hasGSTDetails = !!(itemData?.tax?.hsn_sac_code && itemData?.tax?.gst);
  return isGSTEnabled || hasGSTDetails;
}
